import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/services/apiService';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

interface DropdownItem {
  key: string;
  name: string;
}

interface GridItem {
  key: string;
  name: string;
  mainCode: string;
  isActive: boolean;
}

@Component({
  selector: 'app-disability',
  standalone: true,
  imports: [FormsModule, CommonModule, ProgressSpinnerModule],
  templateUrl: './disability.component.html',
  styleUrl: './disability.component.css'
})
export class DisabilityComponent implements OnInit {

  // dropdowns
  mainList: DropdownItem[] = [];
  subList: DropdownItem[] = [];


  selectedMain: string = '';
  selectedSub: string = '';
  showConfirm = false;
  activeTab: string = 'medical';

  // grid
  subSubList: GridItem[] = [];

  loading = false;

  constructor(private apiService: ApiService, private route: ActivatedRoute,private authService:AuthService, private router: Router) {}

 async ngOnInit(): Promise<void> {

  this.route.queryParams.subscribe(async params => {
    const token = params['token'];

    if (token) {
      localStorage.setItem('access_token', token);
      this.authService.setToken(token);

      this.router.navigate([], {
        queryParams: {},
        replaceUrl: true
      });

      await this.getMain(); // wait until finished

      window.location.reload(); // refresh
    } else {
      await this.getMain();
    }
  });
}




openConfirm() {
  this.showConfirm = true;
}

confirmUpdate() {
  this.showConfirm = false;
  this.updateAll(); // your original function
}

  // MAIN
  async getMain() {
    this.loading= true;
    const req = this.apiService.getGetter('Disabilites/GetMainDisabilite');
    const res: any = await firstValueFrom(req);

    this.mainList = res.list.map((x: any) => ({
      key: x.mainCode,
      name: x.name
    }));
   this.loading = false;
  }

  // SUB
  async onMainChange() {
    this.loading = true;
    if (!this.selectedMain) return;

    this.subSubList = [];
    this.selectedSub = '';

    const req = this.apiService.getGetter(
      `Disabilites/GetSubDisabilite?code=${encodeURIComponent(this.selectedMain)}`
    );

    const res: any = await firstValueFrom(req);

    this.subList = res.list.map((x: any) => ({
      key: x.mainCode,
      name: x.name
    }));
    this.loading = false;
  }

  // SUB SUB GRID
  async onSubChange() {
    if (!this.selectedSub) return;

    this.loading = true;

    const req = this.apiService.getGetter(
      `Disabilites/GetSubSubDisabilite?subCode=${encodeURIComponent(this.selectedSub)}`
    );

    const res: any = await firstValueFrom(req);

    this.subSubList = res.list.map((x: any) => ({
      key: x.key,
      name: x.name,
      mainCode: x.mainCode,
      isActive: x.isActive
    }));

    this.loading = false;
  }


  // UPDATE ALL
 async updateAll() {
  const payload = {
    list: this.subSubList.map(item => ({
      id: item.key,
      isActive: item.isActive
    }))
  };

  console.log(payload);

  try {
    const req = this.apiService.postGetter(
      'Disabilites/UpdateDisabilityStatus',
      payload
    );

    const res: any = await firstValueFrom(req);

    if (res?.value) {
      alert('Updated successfully');
    } else {
      alert('Update failed');
    }

  } catch (error) {
    console.error('Error in updateAll:', error);
  }
}
}